// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"141":"744f24f34ed0730e","757":"81dfe349c81d39bb","881":"b047ec4b340b6702","3262":"b047ec4b340b6702","3353":"cf0201d85ae895ea","7394":"fa91f25e1027622e"}[chunkId] + ".js";
};